<template>
  <div class="pb-container pull-left d-block w-100">
    <div class="pb-terms pb-w-100 pl-30 pr-30">
      <div class="flexbox-container-md">
        <div class="col-lg-10 col-xs-12 pr-0 pl-0">
          <div class="w-100">
            <login v-if="state == 'login'" />
            <create-account v-else />
            <div class="pb-domain-term pull-left">
              <div v-if="state == 'login'" class="title">
                {{ $t('account.create_an_account') }}
                <a class="text-bold link-info" v-track="{ category: 'plan-builder', action: 'click', label: 'create_account' }" @click="state = 'signup'">
                  {{ $t('account.create_account') }}
                </a>
              </div>
              <div v-else class="title">
                {{ $t('account.already_have_an_account') }}
                <a class="text-bold link-info" v-track="{ category: 'plan-builder', action: 'click', label: 'login_link' }" @click="state = 'login'" role="button">
                  {{ $t('account.log_in') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreateAccount from './CreateAccount';
import Login from './Login';

export default {
  name: 'Account',

  components: {
    CreateAccount,
    Login
  },

  data() {
    return {
      state: 'login'
    };
  }
};
</script>
